import TeammateBasicInfo from '@/components/teammates/TeammateBasicInfo';
import TeammateDetailsView from '@/components/teammates/TeammateDetailsView';
import TeammateDetailsActions from '@/components/teammates/TeammateDetailsActions';
import { SVButton, SVLoader } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { ROUTES } from '@/constants/routes';
import { useGetTeammateDetails } from '@/hooks/requests/useTeammates';
import { Card, Grid, Stack, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { createFullName } from '@/utils/string';

export default function TeammateDetailPage() {
  const navigate = useNavigate();
  const { uuid = '' } = useParams();
  const { teammateDetails, isTeammateDetailsPending } =
    useGetTeammateDetails(uuid);
  const teammateFullName = createFullName(
    teammateDetails?.user?.firstName,
    teammateDetails?.user?.lastName,
  );

  if (isTeammateDetailsPending) {
    return (
      <DefaultLayout header="Teammate Details">
        <Card>
          <SVLoader />
        </Card>
      </DefaultLayout>
    );
  }

  if (!teammateDetails) {
    return (
      <DefaultLayout header="Teammate Details">
        <Card>
          <Typography>
            Something went wrong retrieving the teammate. Our team has been
            notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout
      header={`${teammateFullName} Details`}
      buttons={[
        <SVButton
          onClick={() =>
            navigate(`${ROUTES.TEAMMATES_EDIT_PARAMS}/${teammateDetails.uuid}`)
          }
          fullWidth
          key="edit"
          aria-label="Edit Teammate">
          Edit
        </SVButton>,
      ]}
      breadcrumb={[
        { label: 'Teammates', href: ROUTES.TEAMMATES },
        { label: teammateFullName, isActive: true },
      ]}>
      <Stack spacing={2}>
        <TeammateBasicInfo teammateDetails={teammateDetails} />
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <TeammateDetailsView teammateDetails={teammateDetails} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <TeammateDetailsActions teammateDetails={teammateDetails} />
          </Grid>
        </Grid>
      </Stack>
    </DefaultLayout>
  );
}
